export default "__VITE_ASSET__RoAVPFfp__"